import { z } from 'zod';
import { BID_PACK_SIZES, type BidPackSize } from './constants';

export const idempotencyKeySchema = z
  .string()
  .min(8)
  .max(128)
  .regex(/^[a-zA-Z0-9_-]+$/, 'idempotency_key must be url-safe');

export const bidPackSizeSchema = z
  .number()
  .int()
  .refine((n): n is BidPackSize => (BID_PACK_SIZES as readonly number[]).includes(n), {
    message: `bid_pack_size must be one of: ${BID_PACK_SIZES.join(', ')}`,
  });

export const createBidPackIntentInputSchema = z.object({
  bid_pack_size: bidPackSizeSchema,
  idempotency_key: idempotencyKeySchema,
});

export type CreateBidPackIntentInput = z.infer<typeof createBidPackIntentInputSchema>;

export const createPaymentIntentResponseSchema = z.object({
  payment_id: z.string(),
  amount_jetton_units: z.number().int().positive(),
  deeplink: z.string().url(),
  expires_at: z.number().int().positive(),
});

export type CreatePaymentIntentResponse = z.infer<typeof createPaymentIntentResponseSchema>;
